import React, {useContext} from 'react';
import {AppCtx} from "../../../AppCtx";
import {FaLevelDownAlt, FaSlash} from 'react-icons/fa';

/** @deprecated Hidden from the simplified catalogue menu. */
export default () => {
  const {isLyricSeparatorEnabled, setIsLyricSeparatorEnabled} = useContext(AppCtx);
  return <div style={{cursor:'pointer',position:'relative'}} 
              onClick={()=>setIsLyricSeparatorEnabled(!isLyricSeparatorEnabled)}
              role="button" tabIndex={0}
              aria-label={isLyricSeparatorEnabled ? "Wyłącz separator linii tekstu" : "Włącz separator linii tekstu"}
              title={isLyricSeparatorEnabled ? "Wyłącz separator linii tekstu" : "Włącz separator linii tekstu"}>
    <FaLevelDownAlt style={{
      color:isLyricSeparatorEnabled?'var(--menu-icon-color)':'var(--menu-icon-inactive-color)',
      transform:'rotate(90deg)'
    }}/>
    {isLyricSeparatorEnabled && 
      <FaSlash style={{position:'absolute',top:0,left:0,color:'var(--text-error)'}}/>}
  </div>;
};
